/* ==========================================================================
   Bead Loom Weaving — theme scripts
   ========================================================================== */
(function () {
  'use strict';

  var theme = (window.theme = window.theme || {});
  var routes = theme.routes || {};

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      value = parts[0].replace(/,/g, '.') + ',' + parts[1];
      return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value);
    }
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
    }
    if (format.indexOf('{{amount}}') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, parts[0] + '.' + parts[1]);
    }
    return (format.indexOf('{{') === -1 ? format : '$') + parts[0] + '.' + parts[1];
  }
  theme.formatMoney = formatMoney;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ------------------------------------------------------------------ */
  /* Overlay                                                             */
  /* ------------------------------------------------------------------ */
  var overlay = $('[data-overlay]');
  function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); } }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function () { overlay.hidden = true; }, 250);
  }
  if (overlay) overlay.addEventListener('click', function () { closeDrawer(); closeMenu(); closeSearch(); });

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */
  var drawer = $('#CartDrawer');

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart || '/cart'; return; }
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.classList.add('no-scroll');
    showOverlay();
    startReservationTimer();
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    hideOverlay();
  }
  theme.openDrawer = openDrawer;
  theme.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest('[data-cart-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); closeSearch(); }
  });

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    $$('[data-cart-count-text]').forEach(function (el) {
      el.textContent = count === 1 ? '1 item' : count + ' items';
    });
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch((routes.cart || '/cart') + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          startReservationTimer();
        }
      })
      .catch(function () {});
  }
  theme.refreshDrawer = refreshDrawer;

  function getCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  theme.getCart = getCart;

  function changeLine(line, quantity) {
    return fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      return refreshDrawer().then(function () { return cart; });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.dataset.line, 10), 0);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.line, 10);
    var input = btn.closest('.quantity').querySelector('input');
    var qty = parseInt(input.value, 10) + parseInt(btn.dataset.cartQty, 10);
    if (qty < 0) qty = 0;
    changeLine(line, qty);
  });

  /* ------------------------------------------------------------------ */
  /* Add to cart (any form with data-type="add-to-cart-form")            */
  /* ------------------------------------------------------------------ */
  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    if (button) button.classList.add('button--loading');
    var formData = new FormData(form);
    if (!formData.get('id')) {
      var idField = form.querySelector('[name="id"]');
      if (idField) formData.set('id', idField.value);
    }

    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Error');
        }
        return getCart().then(function (cart) {
          updateCartCount(cart.item_count);
          if (theme.cartType === 'drawer') {
            return refreshDrawer().then(function () { openDrawer(); });
          }
          window.location.href = routes.cart || '/cart';
        });
      })
      .catch(function (err) {
        window.alert(err.message || 'Could not add to cart.');
      })
      .then(function () {
        if (button) button.classList.remove('button--loading');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  /* Upsell "+" buttons — add a single product without leaving the page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.upsellAdd;
    btn.classList.add('button--loading');
    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        btn.classList.remove('button--loading');
        btn.classList.add('is-added');
        btn.innerHTML = '<svg class="icon" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>';
        return getCart().then(function (cart) { updateCartCount(cart.item_count); return refreshDrawer(); });
      })
      .catch(function (err) {
        btn.classList.remove('button--loading');
        window.alert(err.message || 'Could not add to cart.');
      });
  });

  /* ------------------------------------------------------------------ */
  /* Quantity selectors                                                  */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.quantity');
    var input = wrap.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '999999', 10);
    var value = parseInt(input.value, 10) || min;
    value += parseInt(btn.dataset.qtyChange, 10);
    if (value < min) value = min;
    if (value > max) value = max;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Bundle / quantity-break options                                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-bundle-input]');
    if (!input) return;
    var group = input.closest('[data-bundle]');
    if (!group) return;
    $$('.bundle-option', group).forEach(function (opt) { opt.classList.remove('is-selected'); });
    var opt = input.closest('.bundle-option');
    if (opt) opt.classList.add('is-selected');

    var form = group.closest('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var qtyInput = form.querySelector('[data-quantity-input]') || document.querySelector('[data-quantity-input]');
    if (qtyInput) {
      var perSet = parseInt(input.dataset.quantity || '1', 10);
      qtyInput.value = perSet;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // optional extra products that belong to this bundle
    var extras = input.dataset.bundleExtras;
    var hidden = form.querySelector('[data-bundle-extras]');
    if (hidden) hidden.value = extras || '';
  });

  /* ------------------------------------------------------------------ */
  /* Product gallery                                                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-index]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var index = thumb.dataset.thumbIndex;
    $$('[data-media-index]', gallery).forEach(function (m) {
      m.hidden = m.dataset.mediaIndex !== index;
    });
    $$('[data-thumb-index]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ------------------------------------------------------------------ */
  /* Variant selection (single option products)                          */
  /* ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-variant-input]');
    if (!input) return;
    var form = input.closest('form[data-type="add-to-cart-form"]');
    if (!form) form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idField = form.querySelector('[name="id"]');
    if (idField) idField.value = input.value;
    var priceTarget = document.querySelector('[data-product-price]');
    if (priceTarget && input.dataset.price) priceTarget.innerHTML = input.dataset.price;
    var stickyBtn = document.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.dataset.upsellAdd = input.value;
    try { history.replaceState({}, '', '?variant=' + input.value); } catch (err) {}
  });

  /* ------------------------------------------------------------------ */
  /* FAQ / accordions                                                    */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-trigger]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.faq__item');
    var panel = item.querySelector('.faq__answer');
    var isOpen = item.classList.contains('is-open');
    if (isOpen) {
      item.classList.remove('is-open');
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  /* ------------------------------------------------------------------ */
  /* Mobile menu                                                         */
  /* ------------------------------------------------------------------ */
  function closeMenu() {
    var nav = $('#HeaderNav');
    if (nav) nav.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var nav = $('#HeaderNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    if (open) showOverlay(); else hideOverlay();
  });

  /* ------------------------------------------------------------------ */
  /* Search modal                                                        */
  /* ------------------------------------------------------------------ */
  function closeSearch() {
    var modal = $('#SearchModal');
    if (modal) modal.hidden = true;
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      e.preventDefault();
      var modal = $('#SearchModal');
      if (modal) { modal.hidden = false; var input = modal.querySelector('input'); if (input) input.focus(); }
      return;
    }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  /* ------------------------------------------------------------------ */
  /* Countdown timers                                                    */
  /* ------------------------------------------------------------------ */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.countdownInit) return;
      el.dataset.countdownInit = '1';

      var endTime;
      if (el.dataset.countdownEnd) {
        endTime = new Date(el.dataset.countdownEnd).getTime();
      } else {
        var minutes = parseFloat(el.dataset.countdownMinutes || '0');
        var key = 'blw-countdown-' + (el.dataset.countdownKey || 'default');
        var stored = null;
        try { stored = window.localStorage.getItem(key); } catch (e) {}
        if (!stored) {
          stored = String(Date.now() + minutes * 60000);
          try { window.localStorage.setItem(key, stored); } catch (e) {}
        }
        endTime = parseInt(stored, 10);
        if (isNaN(endTime) || endTime < Date.now()) {
          endTime = Date.now() + minutes * 60000;
          try { window.localStorage.setItem(key, String(endTime)); } catch (e) {}
        }
      }

      var daysEl = el.querySelector('[data-days]');
      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds]');

      function tick() {
        var diff = endTime - Date.now();
        if (diff < 0) diff = 0;
        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart reservation timer                                              */
  /* ------------------------------------------------------------------ */
  function startReservationTimer() {
    var el = document.querySelector('[data-reservation-timer]');
    if (!el) return;
    var minutes = parseFloat(el.dataset.reservationMinutes || '5');
    var key = 'blw-cart-reservation';
    var end = null;
    try { end = window.localStorage.getItem(key); } catch (e) {}
    if (!end || parseInt(end, 10) < Date.now()) {
      end = String(Date.now() + minutes * 60000);
      try { window.localStorage.setItem(key, end); } catch (e) {}
    }
    end = parseInt(end, 10);

    function tick() {
      var diff = end - Date.now();
      if (diff < 0) diff = 0;
      var total = Math.floor(diff / 1000);
      var m = Math.floor(total / 60);
      var s = total % 60;
      el.textContent = pad(m) + ':' + pad(s);
    }
    tick();
    if (window.__blwReservationInterval) clearInterval(window.__blwReservationInterval);
    window.__blwReservationInterval = setInterval(tick, 1000);
  }
  theme.startReservationTimer = startReservationTimer;

  /* ------------------------------------------------------------------ */
  /* Sticky add to cart bar                                              */
  /* ------------------------------------------------------------------ */
  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(anchor);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Newsletter (inline AJAX)                                            */
  /* ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-newsletter-form]');
    if (!form) return;
    e.preventDefault();
    var message = form.parentNode.querySelector('[data-newsletter-message]');
    var formData = new FormData(form);
    fetch(form.action, { method: 'POST', body: formData })
      .then(function (r) { return r.text(); })
      .then(function () {
        if (message) {
          message.textContent = 'Thanks for subscribing!';
          message.className = 'newsletter__message newsletter__message--success';
        }
        form.reset();
      })
      .catch(function () {
        if (message) {
          message.textContent = 'Something went wrong. Please try again.';
          message.className = 'newsletter__message newsletter__message--error';
        }
      });
  });

  /* ------------------------------------------------------------------ */
  /* Reveal on scroll                                                    */
  /* ------------------------------------------------------------------ */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                */
  /* ------------------------------------------------------------------ */
  function init() {
    initCountdowns();
    initStickyBar();
    initReveal();
    startReservationTimer();
    var cartCount = theme.cart && theme.cart.item_count ? theme.cart.item_count : 0;
    updateCartCount(cartCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initCountdowns();
    initReveal();
  });
})();
